module.exports = __webpack_public_path__ + "media/cursor-back.3246cb76.mp3";